module.exports = __webpack_public_path__ + "img/dictionary_icon.8441fa90.svg";